var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.707 8.70711C11.0975 8.31658 11.0975 7.68342 10.707 7.29289L6.70696 3.29289C6.31643 2.90237 5.68327 2.90237 5.29274 3.29289C4.90222 3.68342 4.90222 4.31658 5.29274 4.70711L8.58564 8L5.29274 11.2929C4.90222 11.6834 4.90222 12.3166 5.29274 12.7071C5.68327 13.0976 6.31643 13.0976 6.70696 12.7071L10.707 8.70711Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/Chevron-Right.31ffcc2c338df07c26dfb14ee508a987.svg";
export { ForwardRef as ReactComponent };